/**
 * useIndustryWording Hook
 * 
 * Provides industry-specific UI labels throughout the application
 */

import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { 
  getIndustryWording, 
  getProductTypesForIndustry,
  getEntityLabel,
  getEntityLabelSingular,
  getActionLabel,
  getDashboardLabel,
  IndustryWording
} from '../data/industryWording';

export function useIndustryWording() {
  const { organization } = useAuth();
  const industry = organization?.industry;

  const wording = useMemo(() => {
    return getIndustryWording(industry);
  }, [industry]);

  const productTypes = useMemo(() => {
    return getProductTypesForIndustry(industry);
  }, [industry]);

  return {
    industry,
    wording,
    productTypes,
    
    // Convenience methods
    getEntityLabel: (entity: 'leads' | 'customers' | 'opportunities' | 'products') => 
      getEntityLabel(entity, industry),
    
    getEntityLabelSingular: (entity: 'lead' | 'customer' | 'opportunity' | 'product') => 
      getEntityLabelSingular(entity, industry),
    
    getActionLabel: (action: 'createLead' | 'createCustomer' | 'createProduct') => 
      getActionLabel(action, industry),
    
    getDashboardLabel: (widget: 'leadsWidget' | 'customersWidget' | 'revenueWidget') => 
      getDashboardLabel(widget, industry)
  };
}

